import { adminDirectUploadFilesApi } from '@views/users/users.api.js'
import moment from 'moment'

export default {
  methods: {
    /**
     * 判断是否为图片文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isImageFile (url) {
      if (!url) return false

      // 最后通过文件扩展名判断
      try {
        const path = new URL(url).pathname
        const ext = path.split('.').pop().toLowerCase()
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'tif'].includes(ext)) {
          console.log(url + ' match img ext')
          return true
        }
      } catch (error) {
        // do nothing
        console.log(error)
      }
      return false
    },
    /**
     * 判断是否为视频文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isVideoFile (url) {
      if (!url) return false

      // 通过 URL 中的存储桶关键字快速判断
      const videoBuckets = ['sjrawvideopub.', 'sjrawvideopubdev.', 'sjvideopub.', 'sjvideopubdev.', 'sjvideopubcnv.', 'sjvideopubcnvdev.']
      if (videoBuckets.some(bucket => url.includes(bucket))) {
        console.log(url + ' match video bucket name')
        return true
      }
      // 最后通过文件扩展名判断
      try {
        const path = new URL(url).pathname
        const ext = path.split('.').pop().toLowerCase()
        if (['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpeg', 'mpg', 'm3u8', 'mpd'].includes(ext)) {
          console.log(url + ' match video ext')
          return true
        }
      } catch (error) {
        // do nothing
      }
      return false
    },
    onChangeUserWorkInfoEvidence (file) {
      const fileType = file.raw.type
      const fileSizeMB = file.raw.size / 1024 / 1024
      const isImage = (fileType === 'image/jpeg') || (fileType === 'image/png')
      const isVideo = (fileType === 'video/mp4')
      if (!isImage && !isVideo) {
        this.$message.error('请上传jpg/png图片或mp4视频!')
        return false
      }
      if (isImage && fileSizeMB > 5) {
        this.$message.error('图片大小不能超过5MB!')
        return false
      }
      if (isVideo && fileSizeMB > 200) {
        this.$message.error('视频大小不能超过200MB!')
        return false
      }
      return this.doAdminDirectUploadFile(file.raw)
    },
    async doAdminDirectUploadFile (file) {
      try {
        const params = {
          file_name: file.name,
          ext: file.name.split('.').pop().toLowerCase(),
          content_type: file.type || 'application/octet-stream',
        }
        const res = await adminDirectUploadFilesApi(params)
        if (res.data.ret === 0) {
          let uploadUrl = res.data.detail.signedUrl
          let contentType = res.data.detail.content_type
          const uploadRes = await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({'Content-Type': contentType}),
            body: file,
          })
          if (!uploadRes.ok) {
            throw new Error(`上传失败，原因: ${uploadRes.status}`)
          }
          this.$message({message: '上传成功', type: 'success'})
          return res.data.detail.url
        } else {
          this.$message.error('上传失败，原因: ' + res.data.msg)
          return false
        }
      } catch (error) {
        this.$message.error('上传失败，原因: ' + error.message)
        return false
      }
    },
    // 附件上传,标准化字段结构
    formatStandardFile (file, loginUser) {
      return {
        submit_admin_id: loginUser.id,
        submit_admin_name: loginUser.name,
        submit_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        name: file.name,
        size: file.size,
        url: file.url,
        uid: file.uid,
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/user-workinfo/user-workinfo.mixin.js